import React from 'react';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';
import { messages } from './messages';

const CompanyComponent = ({ fulfillmentPlanId }) => {
  const { labelConfiguration, externalFulfillmentConfiguration } = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanById(state, { fulfillmentPlanId }),
  );

  const { company } = labelConfiguration?.shipTo ?? externalFulfillmentConfiguration?.shipTo ?? {};

  return company ?? '';
};

export const Company = {
  getMessageDescriptor: () => messages.company,
  id: 'company',

  render: (data, { isExpanded = false, isFirstRow = true } = {}) => {
    if (isExpanded && !isFirstRow) {
      return '';
    }

    return <CompanyComponent fulfillmentPlanId={data.id} />;
  },
};
